import React from 'react';
import { compose, setDisplayName } from 'recompose';
import classnames from 'classnames';
import baseStyles from '../EmailConfirmationPage.scss';
import styles from './EmailConfirmationFailure.scss';

export const EmailConfirmationFailure = () => (
  <div>
    <h2 className={classnames(baseStyles.title, styles.title)}>Verification Unsuccessful</h2>
    <p className={baseStyles.paragraph}>
        We could not successfully verify your email address.
        Please make sure you are using the link from the most recent verification emails sent to you.
    </p>

  </div>
);

export default compose(setDisplayName('EmailConfirmationFailure'))(EmailConfirmationFailure);
